import { MenuDivider } from "@focus/focusUI";
import React from "react";
import { useState } from "react";
import { addDataChange, changesToMultiEditIntent } from "../entities/formData";
import { ListContext } from "../focusList/ListContext";
import { ChangesList } from "./ChangesList";
import { FocusFormValidator } from "./FocusFormValidator";
import { MultiEditSelector } from "./MultiEditSelector";
import { flattenData, FocusFormDataContext } from "./utils";
export const FocusFormMultiEdit = ({ schema, uiSchema, formData, multiEditConfig, onChange, }) => {
    const [changes, setChanges] = useState({});
    const [targetId, setTargets] = useState("");
    const [data, setData] = useState(formData);
    const flattenedData = flattenData(schema, uiSchema, data);
    const hasChanges = Object.keys(changes).length > 0;
    const handleChange = (newData, delta) => {
        setData(newData);
        const newChanges = addDataChange(changes, delta);
        setChanges(newChanges);
        const targets = multiEditConfig.find((config) => config.label === targetId) || { appliesTo: [] };
        onChange(changesToMultiEditIntent(newChanges, targets.appliesTo));
    };
    const onChangeMultiedit = (value) => {
        setTargets(value);
        const targets = multiEditConfig.find((config) => config.label === value) || {
            appliesTo: [],
        };
        onChange(changesToMultiEditIntent(changes, targets.appliesTo));
    };
    return (React.createElement("div", { className: "form-container in-dialog", key: "container" },
        React.createElement(MultiEditSelector, { config: multiEditConfig, onChange: onChangeMultiedit }),
        hasChanges ? React.createElement(ChangesList, { changes: changes }) : null,
        React.createElement(MenuDivider, null),
        React.createElement(ListContext.Provider, { value: true },
            React.createElement(FocusFormDataContext.Provider, { value: flattenedData },
                React.createElement(FocusFormValidator, { key: "validation", schema: schema, uiSchema: uiSchema, formData: data, readOnly: false, needsDefaults: false, hideErrorList: true, onChange: handleChange })))));
};
//# sourceMappingURL=FocusFormMultiEdit.js.map